import { getMeta } from '@helpcenter/meta';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri, HelpPageAri } from '@atlassian/ari';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { buildPortalPageAri, isPortalPage } from '@atlassian/company-hub-common';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import HubHomeContentWrapperQuery from '@atlassian/hub-home/HubHomeContentWrapperQueryParameters';
import type { hubHomeContentWrapperQuery } from '@atlassian/hub-home/HubHomeContentWrapperQueryParameters';

export const getPageIdFromMatch = (match: {
	params: Record<string, string | null | undefined>;
}): string => {
	if (FeatureGates.checkGate('portal-pages-in-hub')) {
		const portalId = match.params.portalId;
		if (portalId) {
			return `portal_page-${portalId}`;
		}
	}
	return match.params.pageId || '';
};

export const EditLayoutResource = createRelayResource<hubHomeContentWrapperQuery>({
	type: 'EDIT_HUB_LAYOUT',
	getQuery: ({ match }, { cloudId }) => {
		const activationId = getMeta('activation-id') || '';
		const helpCenterId = match.params.helpcenterId || '';
		const pageId = getPageIdFromMatch(match);
		const computedHelpCenterAri = HelpHelpCenterAri.create({
			activationId,
			helpCenterId,
		}).toString();
		const resolvedPageId = pageId || helpCenterId;
		const computedPageAri =
			isPortalPage(resolvedPageId) && helpCenterId
				? buildPortalPageAri(computedHelpCenterAri, resolvedPageId)
				: HelpPageAri.create({ activationId, pageId: resolvedPageId }).toString();
		const isDraft = FeatureGates.checkGate('help_hubs_draft_mode');
		return {
			parameters: HubHomeContentWrapperQuery,
			variables: {
				cloudId,
				isDraft,
				hubAri: computedHelpCenterAri,
				hubEditMode: true,
				pageAri: computedPageAri,
			},
			options: {
				fetchPolicy: 'store-or-network',
			},
		};
	},
});
